import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate, CanActivateChild {
  private _userService = inject(UserService);
  router = inject(Router);

  async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const user = await this._userService.isLogged();
    if (!user) {
      this.router.navigate(['/login']);
    }
    return !!user;
  }

  canActivateChild(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.canActivate(null, null);
  }
}
